import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["dashboardFilters", "forceBIUtils", "googleMapsApiKey", "getSnapshot", "initWidget"];
import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import GridMotion from "../../../../components/GridMotion";
import { BASE_LAYOUT_SPECS } from "../../constants";
import Widget from "../Widget";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'GridContainer');
const GridContainer = /*#__PURE__*/memo(_ref => {
  let {
      dashboardFilters,
      forceBIUtils,
      googleMapsApiKey,
      getSnapshot,
      initWidget
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(GridMotion, _extends({
    dashboardFilters: dashboardFilters,
    forceBIUtils: forceBIUtils,
    googleMapsApiKey: googleMapsApiKey,
    getSnapshot: getSnapshot,
    baseLayoutSpecs: BASE_LAYOUT_SPECS,
    widgetComp: Widget,
    initWidget: initWidget,
    isLazy: true
  }, props)));
});
export default GridContainer;